import { notificationToggleExpires, notificationUpdateModel } from "../../../actions/notification-actions"

import buildItemConnector from "../../common/build-item-connector"

const mapDispatchToProps = dispatch => ({
    onExpiresToggle: () => dispatch(notificationToggleExpires())
})

export default buildItemConnector(
    "notifications",
    false,
    notificationUpdateModel,
    null,
    {},
    null,
    mapDispatchToProps
)
